import { render, staticRenderFns } from "./approveNewSuffix.vue?vue&type=template&id=77b74887&"
import script from "./approveNewSuffix.vue?vue&type=script&lang=js&"
export * from "./approveNewSuffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports